import { ReactNode } from "react"
import {
  Block,
  BlockProps,
  HeadingLarge,
  ParagraphMedium,
  useStyletron,
} from "@mezo-org/mezo-clay"

type StatsCardProps = BlockProps & {
  value: ReactNode
  title: ReactNode
  label?: ReactNode
}

export default function StatsCard({
  value,
  title,
  label,
  ...props
}: StatsCardProps) {
  const [css, theme] = useStyletron()

  return (
    <Block
      className={css({
        background: theme.colors.white,
        borderRadius: "12px",
        padding: theme.sizing.scale800,
        position: "relative",
        height: theme.sizing.scale3200,
      })}
      {...props}
    >
      <ParagraphMedium
        as="div"
        color={theme.colors.contentSecondary}
        marginBottom={theme.sizing.scale600}
      >
        {title}
      </ParagraphMedium>
      {label}
      <HeadingLarge>{value}</HeadingLarge>
    </Block>
  )
}
